export default __webpack_public_path__ + "static/media/blush-dark-autumn.390918a0.png";